import httpClient from '@utils/httpClient.js';

export function updateLinkApiCall({
  blockId,
  isEdit,
  id,
  igUserId,
  title,
  description,
  isActive,
  isCustomDesign,
  animation,
  url,
  n,
  image,

  button,
  buttonColor,
  label,
  labelColor,

  imageShape,
  backgroundColor,
  opacity,
  height,
  imageHeight,
  textColor,
  headerTitle,
  headerTextAlign,
  headerDescription,
  headerTextColor,
  headerImage,
  headerDevided,
  isDisplayArrow,
  urlType,
  textAlign,
  rightArrow,
  pageTitle,
  pageDescription,
  pageImage,
  pageBtnTitle,
  pageBtnColor,
  pageBtnUrl,
  internalPageId,
  isBorder,

  isLock,
  isPayable,

  isGradient,
  gradientColor1,
  gradientColor2,
  gradientDirection,
  gradientOffset,

  defaultButtonBackgroundColor,
  defaultButtonTextColor,
  defaultButtonOpacity,
  defaultButtonHeight,
  defaultButtonTextAlign,
  defaultButtonRightIcon,
  defaultButtonIsGradient,
  defaultButtonGradientColor1,
  defaultButtonGradientColor2,
  defaultButtonGradientDirection,
  defaultButtonGradientOffset,
}) {
  const method = isEdit ? 'put' : 'post';

  return httpClient[method](`api/link-blocks/${blockId}/items${isEdit ? '/' + id : ''}`, {
    blockId,
    igUserId,
    title,
    description,
    isActive,
    isCustomDesign,
    animation,
    url,
    n,
    image,

    button,
    buttonColor,
    label,
    labelColor,

    imageShape,
    backgroundColor,
    opacity,
    height,
    imageHeight,
    textColor,
    headerTitle,
    headerTextAlign,
    headerDescription,
    headerTextColor,
    headerImage,
    headerDevided,
    isDisplayArrow,
    urlType,
    textAlign,
    rightArrow,
    pageTitle,
    pageDescription,
    pageImage,
    pageBtnTitle,
    pageBtnColor,
    pageBtnUrl,
    internalPageId,
    isBorder,

    isLock,
    isPayable,

    isGradient,
    gradientColor1,
    gradientColor2,
    gradientDirection,
    gradientOffset,

    defaultButtonBackgroundColor,
    defaultButtonTextColor,
    defaultButtonOpacity,
    defaultButtonHeight,
    defaultButtonTextAlign,
    defaultButtonRightIcon,
    defaultButtonIsGradient,
    defaultButtonGradientColor1,
    defaultButtonGradientColor2,
    defaultButtonGradientDirection,
    defaultButtonGradientOffset,
  });
}

export function deleteLinkApiCall(id) {
  return httpClient.delete(`api/link-blocks/${blockId}/items/${id}`);
}

export function sortLinkApiCall(links) {
  return httpClient.put(`api/link-blocks/${blockId}/items/sort`, {
    links,
  });
}
